import axios from "axios";
import axiosInstance from "@/lib/axios";
import type {
  SearchContentResponse,
  SearchQueryParams,
  SearchSuggestionsResponse,
  SearchSuggestionsQueryParams,
  SearchApiErrorResponse,
} from "@/types/search";

const SEARCH_URL = "/search";
const SUGGESTIONS_URL = "/search/suggestions";

export async function searchContent(
  params: SearchQueryParams,
  signal?: AbortSignal,
): Promise<SearchContentResponse> {
  try {
    const { data } = await axiosInstance.get<SearchContentResponse>(SEARCH_URL, {
      params,
      signal,
      withCredentials: true,
    });
    return data;
  } catch (err: unknown) {
    if (axios.isAxiosError(err)) {
      if (axios.isCancel(err)) throw err;
      const apiError = err.response?.data as SearchApiErrorResponse;
      throw apiError;
    }
    throw err;
  }
}

export async function getSearchSuggestions(
  params: SearchSuggestionsQueryParams,
  signal?: AbortSignal,
): Promise<SearchSuggestionsResponse> {
  try {
    const { data } = await axiosInstance.get<SearchSuggestionsResponse>(SUGGESTIONS_URL, {
      params,
      signal,
      withCredentials: true,
    });
    return data;
  } catch (err: unknown) {
    if (axios.isAxiosError(err)) {
      if (axios.isCancel(err)) throw err;
      const apiError = err.response?.data as SearchApiErrorResponse;
      throw apiError;
    }
    throw err;
  }
}
